import { render, staticRenderFns } from "./dm-detail-wenxian.vue?vue&type=template&id=fdd47afc&scoped=true"
import script from "./dm-detail-wenxian.vue?vue&type=script&lang=js"
export * from "./dm-detail-wenxian.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-wenxian.vue?vue&type=style&index=0&id=fdd47afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd47afc",
  null
  
)

export default component.exports